<template>
  <div class="container">
    <div class="ban-box">
      <van-image
        src="https://files.alighting.com/Cover/special_20220524.png"
        class="bg"
        fit="contain"
      ></van-image>
      <div class="ban_ul">
        <div @click="toLink(1)">首页</div>
        <div @click="toLink(2)">品牌连线</div>
        <div>品牌新品推荐</div>
        <!-- <div @click="toLink(3)">品牌直播</div> -->
      </div>
    </div>
    <!-- 动态 -->
    <div class="trends-box">
      <van-notice-bar
        v-if="operateList[0].length > 0"
        scrollable
        text=""
        background="#ffffff"
        speed="40"
      >
        <div class="tb_ul">
          <div
            class="tb_item"
            v-for="(item, index) in operateList[0]"
            :key="index"
          >
            <van-image
              fit="cover"
              :src="item.Photo"
              round
              error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
            ></van-image>
            <span>新品点评官{{ item.CompanyName }}{{ item.Duty }}</span>
          </div>
        </div>
      </van-notice-bar>
      <van-notice-bar
        v-if="operateList[1].length > 0"
        scrollable
        text=""
        background="#ffffff"
        speed="40"
      >
        <div class="tb_ul">
          <div
            class="tb_item"
            v-for="(item, index) in operateList[1]"
            :key="index"
          >
            <van-image
              fit="cover"
              :src="item.Photo"
              round
              error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
            ></van-image>
            <span>新品点评官{{ item.CompanyName }}{{ item.Duty }}</span>
          </div>
        </div>
      </van-notice-bar>
    </div>
    <!-- 类型 -->
    <div class="classify">
      <div
        v-for="(item, index) in brandClassify"
        :key="index"
        :id="'tab' + item.type"
        :class="type == item.type ? 'active' : ''"
        @click.stop="classifySelect(item.type)"
      >
        {{ item.Name }}
      </div>
    </div>
    <!-- 搜索 -->
    <div class="sb_search">
      <input
        type="search"
        v-model="keyword"
        placeholder="请输入搜索内容"
        @keydown.enter.native="searchHandle"
      />
      <img
        src="../../../static/images/live/icon_search.png"
        style="width: 20px; height: 20px"
        @click.stop="searchHandle"
      />
    </div>

    <!-- 视频列表 -->
    <van-list
      class="video-list"
      v-if="list.length > 0"
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="getList"
    >
      <div class="videoItem" v-for="(item, index) in list" :key="index">
        <mini-program
          :path="'/pages/videoDetail/videoDetail?vid=' + item.VodId"
        >
          <div class="v_top">
            <van-image
              :src="item.CoverUrl"
              fit="contain"
              class="vImg"
            ></van-image>
            <img src="../../../static/images/index/play.png" class="playIcon" />
          </div>
        </mini-program>
        <div class="v_btm overFlowOne">{{ item.Title }}</div>
        <div class="company">
          <van-image :src="item.HeadLineLogo" fit="contain"></van-image>
          <div class="overFlowOne">{{ item.HeadLine }}</div>
        </div>
      </div>
    </van-list>
    <div class="noDataBox" v-else style="padding-bottom: 68px">
      <div class="kongIcon"><span class="iconfont icon-kong"></span></div>
      <div>什么也没有！</div>
    </div>
  </div>
</template>
<script>
import { NoticeBar, Image, List, Search } from "vant";
import { exhActivityMemberLogsForHome, exhActivityVodList } from "@/api/online";
import miniProgram from "@/components/miniProgram";
export default {
  name: "newBrands",
  components: {
    "van-notice-bar": NoticeBar,
    "van-image": Image,
    "van-list": List,
    "van-search": Search,
    miniProgram,
  },
  data() {
    return {
      operateList: [[], []], //动态列表

      type: 0,
      id: "tab1",
      brandClassify: [
        {
          type: 0,
          Name: "全部",
        },
        {
          type: 1,
          Name: "文旅景观照明",
        },
        {
          type: 2,
          Name: "家居灯饰",
        },
        {
          type: 3,
          Name: "道路照明",
        },
        {
          type: 5,
          Name: "商业照明",
        },
        {
          type: 6,
          Name: "光健康",
        },
        {
          type: 4,
          Name: "智能照明",
        },
        {
          type: 7,
          Name: "电源及配件",
        },
        {
          type: 8,
          Name: "其他",
        },
      ],

      keyword: "",
      list: [], //视频列表
      pageIndex: 1,
      total: 0,
      error: false,
      loading: false,
      finished: false,
    };
  },

  watch: {
    $route: {
      handler: function (to, from) {
        var that = this;
        that.type = that.$route.query.type;
        that.error = false;
        that.loading = false;
        that.finished = false;
        that.total = 0;
        that.pageIndex = 1;
        that.list = [];
      },
      immediate: true,
    },
  },

  methods: {
    toLink(n) {
      if (n == 1) {
        this.$router.replace({ path: "/onlineExhibitionTopics" });
      } else if (n == 2) {
        this.$router.push({ path: "/brandLive" });
      } else if (n == 3) {
        this.$router.push({ path: "/lbList", query: { sid: 13, lid: 75 } });
      }
    },
    //动态
    getOperateList() {
      var that = this;
      exhActivityMemberLogsForHome().then((res) => {
        var list = res.Data.List;
        if (list.length <= 16) {
          that.operateList[0] = list;
          that.operateList[1] = [];
        } else {
          var half = Math.ceil(list.length / 2);
          var firstHalf = list.splice(0, half);
          var secondHalf = list.splice(-half);
          that.$set(that.operateList, 0, firstHalf);
          that.$set(that.operateList, 1, secondHalf);
        }
      });
    },

    //搜索
    searchHandle() {
      this.type = Number(this.type);
      this.pageIndex = 1;
      this.list = [];
      this.getList();
    },

    //分类切换
    classifySelect(type) {
      this.type = Number(type);
      this.id = "tab" + type;
      this.pageIndex = 1;
      this.list = [];
      this.getList();
    },

    //获取直播列表
    getList() {
      var that = this;
      var data = {
        PageModel: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
        SpecialId: Number(that.type),
        Keyword: that.keyword,
      };
      exhActivityVodList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },
  },
  mounted() {
    if (!this.Common._isMobile()) {
      window.location.href =
        "https://www.alighting.com/Views/2022onlineexhibition/newpro.html?id=" +
        this.$route.query.type;
    } else {
      this.type = Number(this.$route.query.type);
      this.id = "tab" + Number(this.$route.query.type);
      document.getElementById(this.id).scrollIntoView(); //跳转定位
      this.getOperateList();
      this.getList();
    }
  },
};
</script>
<style scoped src="../../../static/css/newBrands.css">
</style>